import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    buildingType: null,
    area: null,
    distance: 30,
    propertySize: null,
    propertyVolume: null,
    buildingYear: '2',
    currentHeating: 'uudiskohde',
    currentConsumption: null,
    propertyPowerDemand: null,
  },
  mutations: {
    setArea(state, payload) {
      state.area = payload;
    },
    setBuildingType(state, payload) {
      state.buildingType = payload;
    },
    setDistance(state, payload) {
      state.distance = payload;
    },
    setPropertySize(state, payload) {
      state.propertySize = payload;
    },
    setPropertyVolume(state, payload) {
      state.propertyVolume = payload;
    },
    setBuildingYear(state, payload) {
      state.buildingYear = payload;
    },
    setCurrentHeating(state, payload) {
      state.currentHeating = payload;
    },
    setCurrentConsumption(state, payload) {
      state.currentConsumption = payload;
    },
    setPropertyPowerDemand(state, payload) {
      state.propertyPowerDemand = payload;
    }
  }
})


export default store;
